"use client";

import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import { isSameDay } from "date-fns";
import { startTransition } from "react";
import ProgramDateButton from "src/components/programdatebutton/ProgramDateButton";
import { useLocationContext, useProgramDatesContext } from "src/lib/contexts/ContextTypes";
import styles from "./ProgramDateButtonRow.module.css";
import ProgramAllDatesButton from "src/components/programdatebutton/ProgramAllDatesButton";

//#region [Props]
type ProgramDateButtonRowProps = {
  className?: string;
  scrollContainerClassName?: string;
  dateClassName?: string;
  dates?: Date[] | null;
  selectedDate?: Date | null;
  isAllSelected?: boolean;
  onButtonClick?: (date: Date) => void;
};
//#endregion

//#region [Component]
export default function ProgramDateButtonRow(t0) {
  const $ = _c(32);
  const {
    className,
    scrollContainerClassName,
    dateClassName,
    dates,
    selectedDate,
    isAllSelected,
    onButtonClick
  } = t0;
  const {
    showAllDates
  } = useLocationContext();
  const {
    setIsShowingAllDates
  } = useProgramDatesContext();
  let t1;
  if ($[0] !== onButtonClick || $[1] !== setIsShowingAllDates) {
    t1 = date => startTransition(() => {
      onButtonClick?.(date);
      setIsShowingAllDates(false);
    });
    $[0] = onButtonClick;
    $[1] = setIsShowingAllDates;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectDate = t1;
  let t2;
  if ($[3] !== setIsShowingAllDates) {
    t2 = showAll => startTransition(() => setIsShowingAllDates(showAll));
    $[3] = setIsShowingAllDates;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectAllDates = t2;
  if ((dates?.length ?? 0) === 0) {
    return null;
  }
  let t3;
  if ($[5] !== scrollContainerClassName) {
    t3 = classNames(styles.ScrollContainer, scrollContainerClassName);
    $[5] = scrollContainerClassName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className) {
    t4 = classNames(styles.ProgramDateButtonRow, className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== dateClassName || $[10] !== isAllSelected || $[11] !== selectAllDates || $[12] !== showAllDates) {
    t5 = showAllDates && <ProgramAllDatesButton isSelected={isAllSelected} className={dateClassName} onClick={selectAllDates} />;
    $[9] = dateClassName;
    $[10] = isAllSelected;
    $[11] = selectAllDates;
    $[12] = showAllDates;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== dateClassName || $[15] !== dates || $[16] !== isAllSelected || $[17] !== selectDate || $[18] !== selectedDate) {
    let t7;
    if ($[20] !== dateClassName || $[21] !== isAllSelected || $[22] !== selectDate || $[23] !== selectedDate) {
      t7 = date_0 => <ProgramDateButton key={date_0.getTime()} date={date_0} className={dateClassName} isSelected={!isAllSelected && selectedDate && isSameDay(selectedDate, date_0)} onClick={selectDate} />;
      $[20] = dateClassName;
      $[21] = isAllSelected;
      $[22] = selectDate;
      $[23] = selectedDate;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    t6 = dates.map(t7);
    $[14] = dateClassName;
    $[15] = dates;
    $[16] = isAllSelected;
    $[17] = selectDate;
    $[18] = selectedDate;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t3 || $[30] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[29] = t3;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
}
//#endregion